import React from 'react';
import { Spinner, Backdrop } from '@patternfly/react-core';
/* eslint-disable */

interface LoadingSpinnerProps {
  isLoading: boolean;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ isLoading }) => {
  if (!isLoading) return null;

  return (
    <Backdrop>
        <Spinner
            size="xl"
            style={{
                position: 'fixed', top: '50%', left: '50%',
                zIndex: 2000,
                width: 40,
                height: 40,
            }}
            isSVG 
        />
    </Backdrop>
  );
};

export default LoadingSpinner;
